import React, { Component } from 'react';
import './DottedBox.css';
import './Goldring.css';

export default class PreviewImage extends Component {
    constructor(props) {
        super(props);
    }

    render() {

        const DottedBox = () => (
            <div className="DottedBox">
                <p className="DottedBox_content">Get started with CSS styling</p>
            </div>
        );

        const GoldRing = () => (
            <div class="containerBox">
                <img class="img-responsive" src={require('./img/all_men_600.jpg')} />
                <div class='text-box'>
                    <p class='dataNumber'> 8 </p>
                </div>
            </div>
        )

        return (
            <div>
                <GoldRing />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/newSite/ImagePreview/PreviewImage.js